import { render, staticRenderFns } from "./BlacklistedClients.vue?vue&type=template&id=320c261a&scoped=true"
import script from "./BlacklistedClients.vue?vue&type=script&lang=js"
export * from "./BlacklistedClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320c261a",
  null
  
)

export default component.exports